import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Tabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(prev => !prev);
  };

  // 👇 Update this to match your custom breakpoint
  const [isLargeScreen, setIsLargeScreen] = useState(() =>
    window.matchMedia("(min-width: 1280px)").matches
  );
  const handleNavigation = (path) => {
    navigate(path); // Use useNavigate to navigate
    setShowDropdown(false); // Optionally close the dropdown after navigation
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1280px)");
    const handleChange = (e) => setIsLargeScreen(e.matches);
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const links = [
    { name: "Home", path: "/" },
    { name: "Physio", path: "/physio" },
    { name: "Ortho", path: "/ortho" },
    { name: "Company", path: "/company" },
  ];

  // ✅ Return different UIs based on custom screen size logic
  if (isLargeScreen) {
    return (
      <div className="bg-gray-light uh-18 m-0 p-0 d-flex justify-content-between align-items-end">
        <div className="d-flex justify-content-start align-items-center upx-10 upy-2 m-0">
          <img src="/raycuraLogoMed.webp" alt="Logo" className="uh-12 uw-15" />
        </div>
        <div className="upx-10 py-0 m-0">
          <ul className="m-0 p-0 d-flex justify-content-end align-items-center list-unstyled text-gradient-blue">
            {links.map(({ name, path }) => (
              <li
                key={name}
                className={`up-5 ufs-5 fw-bold text-decoration-none ${
                  location.pathname === path ? "border-bottom-blue" : ""
                }`}
                onClick={() => navigate(path)}
                style={{ cursor: "pointer" }}
              >
                {name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  } else {
    return (
      <div className="position-relative">
      {/* Navbar */}
      <nav className="uh-44 bg-gray-light d-flex justify-content-between align-items-center">
        <div className="d-flex justify-content-start align-items-center upx-10 upy-2 m-0">
          <img src="/raycuraLogoMed.webp" alt="Logo" className="uh-26" />
        </div>

        <div className="upx-10 m-0" style={{ cursor: "pointer" }}>
          <i className="ufs-14 fa-solid fa-bars" onClick={toggleDropdown}></i>
        </div>
      </nav>

      {/* Dropdown shown below navbar, using w-100 for full width */}
      {showDropdown && (
        <div className="position-absolute top-100 start-0 w-100 bg-gray-light border-top shadow z-3 "
        style={{opacity:"0.9"}}>
          <ul className="list-unstyled m-0 p-3 text-blue bg-gray-light">
            {links.map(({ name, path }) => (
              <li
                key={name}
                className="up-2 m-0 ufs-9 fw-bold bg-gray-light"
                onClick={() => handleNavigation(path)} // Handle navigation
                style={{ cursor: "pointer" }}
              >
                {name}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
    );
  }
}
